/**
 * 原文视图业务逻辑钩子
 * 提供原文展示和文本选择的核心业务逻辑
 */
import { useCallback, useMemo } from 'react';
import { useTextSelection } from './useTextSelection.js';
import { useSelectionEventHandler } from '../contexts/index.js';
/**
 * 原文视图业务逻辑钩子
 */
export function useOriginalTextView(params) {
    const { showActionButtons, startHideActionButtonsTimer: _startHideActionButtonsTimer, allParagraphs, } = params;
    // Get the onSelectionChange callback from the context
    const { onSelectionChange } = useSelectionEventHandler();
    // 使用文本选择钩子, pass onSelectionChange from context to useTextSelection
    // 使用 useMemo 创建段落映射表，仅在 allParagraphs 改变时重新计算
    const paragraphMap = useMemo(() => {
        return new Map(allParagraphs.map(p => [p.id, p]));
    }, [allParagraphs]);
    const { handleParagraphSelection } = useTextSelection({
        onTextSelect: onSelectionChange,
        paragraphMap: paragraphMap,
    });
    // 处理段落选择 (鼠标事件)
    const handleParagraphMouseSelection = useCallback((e, paragraph) => {
        handleParagraphSelection(e, paragraph);
    }, [handleParagraphSelection]);
    // 处理段落选择 (触摸事件)
    const handleParagraphTouchSelection = useCallback((e, paragraph) => {
        handleParagraphSelection(e, paragraph);
    }, [handleParagraphSelection]);
    // It seems there was no plain text selection handling being exposed or used from useOriginalTextView previously.
    // If needed, handlePlainTextSelection from useTextSelection can also be used/exposed.
    // 处理已翻译单词点击
    const handleTranslatedWordClick = useCallback((word) => {
        if (showActionButtons) {
            showActionButtons(word, document.createElement('div'));
        }
    }, [showActionButtons]);
    // 错误处理函数
    const handleComponentError = useCallback((_error, _info) => {
        // 移除console.error语句，可以在这里集成日志服务
        // 未来可以添加: LoggerService.getInstance().error('TranslatedWordHighlighter 组件错误', { error, info });
    }, []);
    return {
        handleParagraphMouseSelection,
        handleParagraphTouchSelection,
        handleTranslatedWordClick,
        handleComponentError,
    };
}
//# sourceMappingURL=useOriginalTextView.js.map